
const ValidateName = (value) => {
    const isValidName = /^(?!.*(?:-{2,}|'{2,}))[A-Za-z-' ]*$/.test(value);
    if (!isValidName)
      return "Please check your entry. Your name cannot include special characters such as ! # $ % &.";
    else return "";
};

export default ValidateName;
